import { ClientT, UserT } from './Users';
import { WorkerT } from './Worker';
import { CompanyT } from './Company';
import { JobWorkerT } from './JobWorker';
import { stringLitArray } from '../utils/utilsT'
import { CargoT } from './CargoT';

const CrewProspectsStatusT = stringLitArray(["pending", "approved", "rejected", 'removedBySelf']);
export type CrewProspectsStatusTStrings = (typeof CrewProspectsStatusT)[number];

export interface CrewProspectsLineItemT {
  id: number
  status: CrewProspectsStatusTStrings
  jobId: number
  workerId: number
  worker?: UserT
  date: string

}


export interface ActivityInvoiceT extends ActivityT {
  duration: number
  isValid: boolean// all fields fill
}

export interface JobRecordT {
  id: number, noShow: boolean
}
export type TypeFinancialT = "revenue" | "cogs" | "expenses"
export interface VariableExpenseT {
  value: number
  rateLabel?: string
  unitsLabel: string
  verboseName: string
}
export interface FiltersT {
  startDate: string
  endDate: string
  jobStatus: Array<string>
  jobType: Array<string>
  client: ClientT | null
}



export enum JobStatusT {
  inquiring = 'inquiring',
  scheduled = 'scheduled',
  completed = 'completed',
  canceled = 'canceled',
  spam = 'spam',
  missed = 'missed',
  refused_price = 'refused_price'
}
export type JobStatusTStrings = keyof typeof JobStatusT;

export enum JobTypeT {
  moving_labor = 'moving_labor',
  intrastate_local = 'intrastate_local',
  intrastate_long = 'intrastate_long',
  interstate = 'interstate',
  international = 'international',
  junk_removal = 'junk_removal',
}
export type JobTypeTStrings = keyof typeof JobTypeT;


export interface ValuationT {
  coverage: number
  deductible: number
  name: string
  premium: number
}

export interface LineItemValuationT {
  accept: string | null
  reject: string | null
}


export interface LineItemsValuationT {
  optionA1: LineItemValuationT
  optionA2: LineItemValuationT
  optionB: LineItemValuationT
}


export enum OptionsValuation {
  releasedValueOption = "releasedValueOption",
  fullReplacementCostOption = "fullReplacementCostOption"
}




export interface VariableT {
  key: string
  type: string
  value: any
}
export interface DocumentT {
  active: boolean
  name: string
  title: string
  variables: Array<VariableT>
  defaultAgreement?: AgreementT
  agreement?: Array<AgreementT>
}

export interface AgreementT {
  type: 'agreement' | 'acknowledgement'
  clause: string
  content?: any
  ip: string
  timestamp: number
  userAgent: string
}


export interface EstimateT extends DocumentT {
  agreement: Array<AgreementT>
}

export interface InvoiceT extends DocumentT { }

export interface ConsumerAdvisementT extends DocumentT {
  defaultAgreement: AgreementT
  agreement: Array<AgreementT>
}






export interface ClientAgreementT extends DocumentT {
  state?: string,
  defaultAgreement: AgreementT
  agreement: Array<AgreementT>
}


export interface ColoradoClientAgreementT extends ClientAgreementT { }

export interface DocumentsT {
  estimate: EstimateT
  invoice: InvoiceT
  clientAgreement?: ClientAgreementT
  coloradoClientAgreement?: DocumentT
  consumerAdvisement?: DocumentT
  [key: string]: DocumentT
}

export interface FinancialLineItem {
  id: string
  date: string
  item: string
  rate: number
  total: number
  units: number
  isDirty?: boolean
  paid?: boolean
  amountPaid?: number | null
  isAutoFill?: boolean
  other?: string
}

export interface CogsLineItemT extends FinancialLineItem {
  workerId?: number | null
}

export interface ExpenseLineItemT extends FinancialLineItem {
  workerId?: number | null
}

export interface WorkerDamageT {
  id?: number
  jobId?: number
  workerId: number       // 0 = anonymous worker
  crewIndex: number      // position in job.crew[]
  amount: number
  notes?: string
  dateRecorded?: string  // ISO date
  worker?: {             // populated by backend on GET
    id: number
    firstName: string
    lastName: string
  }
}


export interface RevenueLineItemT extends FinancialLineItem { }
export interface FinancialT {
  cogs: {
    isDirty: boolean,
    lineItems: Array<CogsLineItemT>
  }
  expenses: {
    isDirty: boolean,
    lineItems: Array<ExpenseLineItemT>
  }
  revenue: {
    isDirty: boolean,
    lineItems: Array<RevenueLineItemT>
  }
}



const PaymentMethodT = stringLitArray(["cash", "cashiers", "card", "check"]);
export type PaymentMethodTStrings = (typeof PaymentMethodT)[number];

const PaymentTypeT = stringLitArray(["deposit", "beforePickup", "beforeDelivery", "afterDelivery", "other"]);
export type PaymentTypeTStrings = (typeof PaymentTypeT)[number];

export const isPaymentTypeT = (x: any): x is PaymentTypeTStrings => PaymentTypeT.includes(x);

export const isPaymentMethodT = (x: any): x is PaymentMethodTStrings => PaymentMethodT.includes(x);

export interface PaymentLineItemT {
  id: string
  amount: number
  amountPaid?: number | null
  date: Date
  method: PaymentMethodTStrings | null
  paymentType: PaymentTypeTStrings | null
  extendedAmount?: number
}
export interface PaymentsT {
  dirty: boolean
  lineItems: Array<PaymentLineItemT>
}

const ActivityTypT = stringLitArray(['', 'load', 'unload', 'pack', 'estimate']);
export type ActivityTypTStrings = (typeof ActivityTypT)[number];
export interface ActivityT {
  id: string
  activityDate: string
  activityType: ActivityTypTStrings | null
  endTime: string
  index: number
  startTime: string
}



export interface LocationT {
  activities: Array<ActivityT>
  address: string
  address2: string
  addressCountry: string
  addressState: string
  elevator: boolean
  latitude: number
  locationSize: number
  locationType: string
  longCarry: number
  longitude: number
  numRooms: number
  numStairFlights: number
  stairsflights: number
}

const ContactMethodT = stringLitArray(['text', 'email', 'call']);
export type ContactMethodTStrings = (typeof ContactMethodT)[number];
export interface ContactPersonT {
  name: string
  phone: number | string
  email: string
  contactMethod: ContactMethodTStrings
  isClient?: boolean
}

export interface ClosedInT {
  communicationId: number
  time: number
}


export interface EstimateLineItemT {
  id?: string,
  item: string
  lineItemDate: string
  rate: number
  total: number
  units: number
  isAutoFill?: boolean
}



export interface InvoiceLineItemT {
  id?: string,
  item: string
  lineItemDate: string
  rate: number
  total: number
  units: number
  isAutoFill?: boolean
}

export interface JobT {
  id: number
  addedBy: number
  cargo: Array<CargoT>
  date?: Date
  billingContact: ClientT,
  client: ClientT
  crew: Array<JobWorkerT>
  documents: DocumentsT
  docs : any
  financial: FinancialT
  isBillingContact: boolean
  jobSource: string
  jobStatus: JobStatusTStrings | JobStatusT
  jobType: JobTypeTStrings | JobTypeT
  locations: Array<LocationT>
  notes: string
  payments: PaymentsT
  companyInfo: CompanyT
  contactPerson: Array<ContactPersonT>
  timeOfScheduling?: Date
  closedIn?: ClosedInT
  lastContactDate?: string
  scheduledDate?: string
  isDateDirty?: boolean
  jobDate?: Date | string
  fkDispute?: number | string
  disputeLink?: string
  damages?: Array<WorkerDamageT>
}
